
        module.exports = __webpack_public_path__ + "assets/images/imec-logo-40years-white.986a2b29.svg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 345,
            height: 200,
            type: "svg",
            bytes: 4011,

            toString: function() {
                return src;
            }
        };
    